module.exports = __webpack_public_path__ + "img/logo_es.d43dc36e.svg";